import { render, staticRenderFns } from "./MessageLoader.vue?vue&type=template&id=ac80aaf0"
import script from "./MessageLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageLoader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports